import { render, staticRenderFns } from "./BaseNav.vue?vue&type=template&id=59f5ea23"
import script from "./BaseNav.vue?vue&type=script&lang=js"
export * from "./BaseNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59f5ea23')) {
      api.createRecord('59f5ea23', component.options)
    } else {
      api.reload('59f5ea23', component.options)
    }
    module.hot.accept("./BaseNav.vue?vue&type=template&id=59f5ea23", function () {
      api.rerender('59f5ea23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navbar/BaseNav.vue"
export default component.exports